import { useStore, useStoreActions } from "../../store/store-context";
import styles from "./ConnectedAppsPage.module.scss";
import { Button, Page, PageErrorState, Typography } from 'seagull';
import { useHistory } from 'react-router';
import { routes } from "../../constants";
import { useMemo } from 'react';
import { capitalize } from 'lodash-es';
import { isLinked } from "../../models/integration";
import getManageIntegrationRoute from "./ConnectedApps.utils";
import { Tab } from "../NotificationSettings/NotificationSettings.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConnectedAppsPage() {
  const {
    data: integrations,
    error
  } = useStore(state => state.integrations);
  const {
    fetchIntegrations
  } = useStoreActions();
  const history = useHistory();
  const onBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(routes.availableApps);
    }
  };
  const onExploreApps = () => {
    history.push(routes.availableApps);
  };
  const sortedAndFilteredIntegrations = useMemo(() => integrations ? [...integrations].sort((a, b) => a.source.localeCompare(b.source)).filter(integration => isLinked(integration)) : [], [integrations]);
  const onManageIntegration = integration => {
    if (integration.source === 'gmail' || integration.source === 'outlook') {
      history.push(routes.notifications, {
        selectedTab: Tab.Client
      });
      return;
    }
    history.push(getManageIntegrationRoute(integration));
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.connectedAppsWrapper,
    children: error ? /*#__PURE__*/_jsx(PageErrorState, {
      "data-testid": "integrations-error-state",
      title: 'Error loading integrations',
      onRefresh: () => fetchIntegrations()
    }) : /*#__PURE__*/_jsx(Page, {
      header: 'Connected apps',
      subheader: "Manage the apps currently connected to your Anchor account.",
      onClickBack: onBack,
      "data-testid": "connected-apps-page",
      children: /*#__PURE__*/_jsx("div", {
        className: styles.integrationsContainer,
        children: sortedAndFilteredIntegrations.length > 0 ? sortedAndFilteredIntegrations.map(integration => /*#__PURE__*/_jsxs("div", {
          className: styles.integration,
          "data-testid": "integration-".concat(integration.source),
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            className: styles.integrationHeader,
            children: integration.source === 'qbo' ? 'Quickbooks Online' : capitalize(integration.source)
          }), /*#__PURE__*/_jsx(Button, {
            "data-testid": "manage-integration-button-".concat(integration.source),
            variant: "secondary",
            size: "medium",
            onClick: () => onManageIntegration(integration),
            className: styles.manageButton,
            children: "Manage"
          })]
        }, integration.source)) : /*#__PURE__*/_jsxs("div", {
          className: styles.emptyStateWrapper,
          "data-testid": "empty-state-container",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            weight: "bold",
            children: "No apps connected yet"
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "secondary",
            children: "Once you do, they'll appear here for easy access and management"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            size: "medium",
            onClick: onExploreApps,
            className: styles.exploreAppsButton,
            "data-testid": "explore-apps-button",
            children: "Explore apps"
          })]
        })
      })
    })
  });
}